import { render, staticRenderFns } from "./calculateSurfaceModal.pug?vue&type=template&id=3b16eaee&lang=pug&"
import script from "./calculateSurfaceModal.js?vue&type=script&lang=js&"
export * from "./calculateSurfaceModal.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b16eaee')) {
      api.createRecord('3b16eaee', component.options)
    } else {
      api.reload('3b16eaee', component.options)
    }
    module.hot.accept("./calculateSurfaceModal.pug?vue&type=template&id=3b16eaee&lang=pug&", function () {
      api.rerender('3b16eaee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/multidamageList/components/calculateSurfaceModal/index.vue"
export default component.exports